import { render, staticRenderFns } from "./membershipcertification.vue?vue&type=template&id=3e9999a6&"
import script from "./membershipcertification.vue?vue&type=script&lang=js&"
export * from "./membershipcertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports